import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { Role } from "@/types/organization-roles";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface GetWorkspaceMemberRolesResponse {
  roles: Role[];
}

export const useGetWorkspaceMemberRoles = (
  workspaceId: number,
  memberId: number,
  enabled = true,
) => {
  const userToken = useUserToken();
  return useQuery({
    queryKey: ["workspace-member-roles", workspaceId, memberId],
    queryFn: async (): Promise<GetWorkspaceMemberRolesResponse> =>
      fetch(ENDPOINTS.get_workspace_member_roles(workspaceId, memberId), {
        method: "GET",
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
    enabled: enabled && !!workspaceId && !!memberId,
  });
};
